import { UserRole } from '../types';

/**
 * Libellé français unifié pour un rôle utilisateur.
 * Source de vérité unique pour toutes les surfaces (liste d'équipe,
 * badge profil, dropdown manager, etc.).
 */
export function roleLabel(role: UserRole | string | undefined | null): string {
  switch (role) {
    case UserRole.SUPER_ADMIN:   return 'Super Admin';
    case UserRole.SUPPORT_USER:  return 'Support';
    case UserRole.COMPANY_ADMIN: return 'Administrateur';
    case UserRole.TEAM_MANAGER:  return "Chef d'équipe";
    case UserRole.MANAGER:       return 'Manager';
    case UserRole.USER:          return 'Utilisateur';
    default:                     return '';
  }
}

/** Variante courte (pour les badges étroits / dropdowns). */
export function roleLabelShort(role: UserRole | string | undefined | null): string {
  switch (role) {
    case UserRole.SUPER_ADMIN:   return 'Super';
    case UserRole.SUPPORT_USER:  return 'Support';
    case UserRole.COMPANY_ADMIN: return 'Admin';
    case UserRole.TEAM_MANAGER:  return "Chef d'équipe";
    case UserRole.MANAGER:       return 'Manager';
    case UserRole.USER:          return 'Utilisateur';
    default:                     return '';
  }
}
